import { CreateQuestionPrompt, PageModule, QuestionPrompt } from '@/types/module.types';
import { LanguagesAbbr } from '@/types/translation.types';
import { Post } from '../helpers';

type CreateQuestionModuleProps = {
  questionPrompt: CreateQuestionPrompt & { channel: number }; // question module as a content module pageModule: number,
  pageModule: number;
  baseLanguage: string | LanguagesAbbr;
  languages: string[] | LanguagesAbbr[];
};
export const CreateQuestionModule = (
  data: CreateQuestionModuleProps
): Promise<{ questionPrompt: QuestionPrompt; pageModule: PageModule }> => {
  return Post({
    path: '/v3/admin/channel/questions',
    body: data,
  });
};
